/* eslint semi:0 */
import { queryString, } from '../../jsCore/utils/window'
import { memoizeFirstCall, } from '../../jsCore/utils/fn'
import { getLeaguesForFixtures, } from '../../jsCore/application/pageDataObject'
import { getNamespacedFetchActionTypes, } from '../../jsCore/application/sagas/fetchSaga'
import { API_ENDPOINT_NAME, SCHEDULE_ACTION_TYPES, } from './scheduleActions'


function getInitialLeague(){
  const { initialLeagueId, } = queryString
  if (!initialLeagueId) {
    if (getLeaguesForFixtures().length === 0) {
      return {}
    }
    const { id: leagueId, name: leagueName, } = getLeaguesForFixtures()[0]
    return { leagueId, leagueName, }
  }
  const leagueId = +initialLeagueId
  const leagueData = getLeaguesForFixtures().find(league => league.id === leagueId)
  const { name: leagueName, } = leagueData
  return { leagueId, leagueName, }
}

function getDefaultState(){
  const { leagueId, leagueName, } = getInitialLeague()
  return {
    IS_INITIALIZED: false,
    leagueId,
    leagueName,
    leaguesForFixtures: getLeaguesForFixtures(),
    numItems: 3,
    scheduleDate: new Date(),
  }
}

function setState(state, newState){
  return { ...state, ...newState }
}

export function scheduleReducer(state = getDefaultState(), action){
  const { SCHEDULE_FETCH_ACTION_TYPES, } = memoizeFirstCall(
    'SCHEDULE_FETCH_ACTION_TYPES',
    getNamespacedFetchActionTypes,
    API_ENDPOINT_NAME
  )
  if (SCHEDULE_FETCH_ACTION_TYPES) {
    switch (action.type) {
      case SCHEDULE_FETCH_ACTION_TYPES.FETCH.SUCCESS:
      case SCHEDULE_FETCH_ACTION_TYPES.FETCH.FAILED:
      case SCHEDULE_ACTION_TYPES.CHANGE_NUM_VISIBLE_ITEMS:
      case SCHEDULE_ACTION_TYPES.CHANGE_LEAGUE:
      case SCHEDULE_ACTION_TYPES.CHANGE_SCHEDULE_DATE:
        return setState(state, action.state)
      default:
        return state
    }
  }
  return setState(state, { IS_ENTRY_POINT_MISSING: true, })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/scheduleReducer.js